import React from 'react'
import TypographyElement from '../../elements/typography'
import WidthContainer from '../../elements/widthContainer'
import { innerHtml } from '../../utils/innerHtml'

const RichTextSection = ({ title, text }) => {
  return (
    <WidthContainer variant="small">
      {title && <TypographyElement variant="title">{title}</TypographyElement>}
      {innerHtml(text)}
    </WidthContainer>
  )
}

export default RichTextSection
